var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42257 5.46789V2.46113C8.42257 2.14142 8.67758 1.875 9.00008 1.875C9.28883 1.875 9.53346 2.09887 9.57223 2.38244L9.57757 2.46113V5.46789L13.1625 5.46812C14.9475 5.46812 16.414 6.92984 16.4964 8.75281L16.5 8.91457V12.694C16.5 14.5298 15.0845 16.0366 13.326 16.1213L13.17 16.125H4.83C3.045 16.125 1.58557 14.6706 1.50363 12.8409L1.5 12.6786L1.5 8.90682C1.5 7.07108 2.90843 5.55691 4.6665 5.47188L4.8225 5.46812H8.4225V10.2699L7.2225 9.03074C6.9975 8.79839 6.63 8.79839 6.405 9.03074C6.2925 9.14691 6.24 9.30181 6.24 9.45671C6.24 9.57443 6.2736 9.6971 6.34464 9.80095L6.405 9.87493L8.5875 12.1364C8.6925 12.2526 8.8425 12.3145 9 12.3145C9.125 12.3145 9.25 12.2715 9.34896 12.1899L9.405 12.1364L11.5875 9.87493C11.8125 9.64258 11.8125 9.26308 11.5875 9.03074C11.383 8.81952 11.0606 8.80031 10.8347 8.97313L10.77 9.03074L9.5775 10.2699V5.46812L8.42257 5.46789Z",
    fill: "#0050AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.f5e18a3d.svg";
export { ForwardRef as ReactComponent };